/**
 * Maths de l'effet « lecture au scroll » : les mots d'un paragraphe se révèlent
 * l'un après l'autre selon la position du paragraphe dans l'écran, en montant
 * d'une opacité basse à leur couleur pleine. Fonctions pures, testées.
 *
 * 21/09/2026 : la variante en FLOU est retirée (décision de Pierre, « je ne
 * veux plus qu'on utilise l'effet défloutage »). Elle venait du site Breakdance
 * (runtime dan-blur-reading) et restait le défaut, donc les trois pages service
 * l'affichaient encore. Le fondu est désormais le seul effet, il n'y a plus de
 * prop pour en changer.
 */

/** Décalage entre deux mots (s). */
export const READING_STAGGER = 0.05;
/** Opacité d'un mot pas encore lu, pour l'effet en fondu. */
export const READING_DIM = 0.15;

const clamp = (value: number) => Math.min(1, Math.max(0, value));

/** 0 quand le centre de l'écran atteint le haut du paragraphe, 1 quand il atteint son bas. */
export function readingProgress(rectTop: number, rectHeight: number, viewportHeight: number): number {
  const center = viewportHeight / 2;
  return clamp((center - rectTop) / Math.max(rectHeight, 1));
}

/** Avancement de la révélation d'un mot, de 0 (pas encore lu) à 1 (lu). */
export function readingWordReveal(
  progress: number,
  index: number,
  count: number,
  { stagger = READING_STAGGER }: { stagger?: number } = {},
): number {
  const duration = 0.5 + Math.max(0, count - 1) * stagger;
  const local = clamp((clamp(progress) * duration - index * stagger) / 0.5);
  return 1 - (1 - local) ** 4; // easeOutQuart, comme le site
}

/** Opacité d'un mot : `dim` tant qu'il n'est pas lu, 1 une fois lu. */
export function readingFadeAmount(
  progress: number,
  index: number,
  count: number,
  { dim = READING_DIM, stagger = READING_STAGGER }: { dim?: number; stagger?: number } = {},
): number {
  return dim + (1 - dim) * readingWordReveal(progress, index, count, { stagger });
}
